import { useState } from "react";
import Divider from "@mui/material/Divider";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { RotateSpinner } from "react-spinners-kit";
import { authenticateUser } from "../../../api/api";

const StudyCancelationForm = (props) => {
  const [loading, setLoading] = useState(false);

  const PROCESSING = loading || props.loading;

  const handleConfirm = async () => {
    if (PROCESSING) return;

    setLoading(true);
    if (Object.values(props.form).some((val) => val.trim() === "")) {
      props.enqueueSnackbar(`ERROR : Please fill in all fields`, {
        preventDuplicate: true,
        variant: "warning",
      });
      setLoading(false);
      return;
    }

    const [res, err] = await authenticateUser(
      props.form.Username,
      props.form.Password
    );

    if (res) {
      if (res.status === 200) {
        props.confirmCancelation();
      } else {
        props.enqueueSnackbar(`ERROR : Invalid credentials - ${res.message}`, {
          preventDuplicate: true,
          variant: "error",
        });
      }
    } else {
      props.enqueueSnackbar(
        `ERROR : Failed to authenticate user - ${err.message}`,
        {
          preventDuplicate: true,
          variant: "error",
        }
      );
    }
    setLoading(false);
  };

  return (
    <Dialog
      open={true}
      onClose={PROCESSING ? () => console.log("") : props.close}
    >
      <DialogTitle sx={{ pl: "10px" }}>
        Please complete the below procedure cancellation form
      </DialogTitle>
      <DialogContent
        sx={{
          background: "#111",
          padding: "8px 10px !important",
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextField
              margin="dense"
              label="Username"
              name="Username"
              type="text"
              fullWidth
              onChange={props.handleChange}
              value={props.form.Username}
              disabled={PROCESSING}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              margin="dense"
              name="Password"
              label="Password"
              type="password"
              fullWidth
              onChange={props.handleChange}
              value={props.form.Password}
              disabled={PROCESSING}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              margin="dense"
              rows={3}
              maxRows={14}
              name="Reason"
              onChange={props.handleChange}
              value={props.form.Reason}
              helperText="Please enter reason for cancelation"
              disabled={PROCESSING}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <Divider />

      <DialogActions>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            onClick={props.close}
            color="primary"
            size="large"
            startIcon={<ClearIcon />}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            color="secondary"
            size="large"
            startIcon={PROCESSING ? null : <SaveIcon />}
          >
            {PROCESSING ? (
              <>
                <RotateSpinner size={20} color="#fff" />
                <span style={{ marginLeft: "2px" }}>Saving</span>
              </>
            ) : (
              <span>Confirm</span>
            )}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default StudyCancelationForm;
